import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthorizedLayoutComponent } from './authorized-layout/authorized-layout.component';
import { BxFooterComponent } from './components/bx-footer/bx-footer.component';
import { BxHeaderComponent } from './components/bx-header/bx-header.component';
import { UnauthorizedLayoutComponent } from './unauthorized-layout/unauthorized-layout.component';
import { RouterModule } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CaptureClicksDirective } from '../directives/capture-clicks.directive';
import { AsmAbilityComponent } from '../components/asm/pages/asm-ability/asm-ability.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';

@NgModule({
  declarations: [
    BxHeaderComponent,
    BxFooterComponent,
    AuthorizedLayoutComponent,
    UnauthorizedLayoutComponent,
    CaptureClicksDirective,
    AsmAbilityComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    AlertModule.forRoot()
  ],
  exports: [
    BxHeaderComponent,
    BxFooterComponent,
    AuthorizedLayoutComponent,
    UnauthorizedLayoutComponent,
    CaptureClicksDirective,
    AsmAbilityComponent,
    AlertModule
  ],
})
export class LayoutsModule {}
